import * as React from 'react';

import RadioGroupContext, { RadioGroupContextValue } from './RadioGroupContext';

export interface RadioGroupState extends RadioGroupContextValue {}

export default function useRadioGroupContext(): RadioGroupState | undefined {
  return React.useContext(RadioGroupContext);
}
